<template>
  <div class="header mt-5 mb-7">
    <div class="subtitle-2">{{ pageSection }}</div>
    <div class="display-1">{{ pageTitle }}</div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data: function () {
    return {
      pageTitle: '',
      pageSection: '',
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.setPageTitle(to)
      },
    },
  },
  created() {
    this.setPageTitle()
  },
  methods: {
    setPageTitle(to, from = null) {
      if (to?.meta) {
        this.pageTitle = to.meta.pageTitle
        this.pageSection = to.meta.pageSection
      }
    },
  },
}
</script>
